export enum CarouselControls {
	PREV = 'PREV',
	NEXT = 'NEXT',
	STOP = 'STOP',
}
